import React from 'react';
import { useTranslation } from 'react-i18next';
import { Ets2AffidavitStatus } from 'features/ets2/enums/ets2AffidavitStatus';
import { ca } from 'date-fns/locale';

interface Props {
  status: Ets2AffidavitStatus;
  className?: string;
  asText?: boolean;
}

const Ets2AffidavitStatusLabel = ({ status, className, asText = false }: Props) => {
  const { t } = useTranslation(['ets2\\enums\\ets2AffidavitStatus']);

  const getStatusClass = (status: Ets2AffidavitStatus, asText: boolean, className?: string) => {
    let colorClass = '';
    switch (status) {
      case Ets2AffidavitStatus.Received:
      case Ets2AffidavitStatus.DocumentsGenerated:
      case Ets2AffidavitStatus.SentForSign:
      case Ets2AffidavitStatus.OperatorReview:
      case Ets2AffidavitStatus.WaitingForSignedDocuments:
        colorClass = 'info';
        break;
      case Ets2AffidavitStatus.ProcessedMixed:
        colorClass = 'warning';
        break;
      case Ets2AffidavitStatus.ProcessedApproved:
        colorClass = 'success';
        break;
      case Ets2AffidavitStatus.ProcessedRejected:
        colorClass = 'danger';
        break;
      case Ets2AffidavitStatus.SignForwardError:
      case Ets2AffidavitStatus.ExceptionCreateError:
      case Ets2AffidavitStatus.Cancelled:
        colorClass = 'default';
        break;
      default:
        colorClass = '';
    }

    const baseClasses = 'small font-weight-normal';
    const contextClass = asText
      ? (colorClass ? `text-${colorClass}` : '')
      : (colorClass ? `badge badge-pill badge-${colorClass}` : 'badge');
    return `${baseClasses} ${contextClass}${className ? ` ${className}` : ''}`;
  };

  return (
    <span className={getStatusClass(status, asText, className)} title={t(status)}>
      {t(status)}
    </span>
  );
};

export default Ets2AffidavitStatusLabel;